import {
  Identifiable,
  Planzone,
  TimeRecordsListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateTimeRecordsListingConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: TimeRecordsListingConfiguration,
    nextConfiguration: TimeRecordsListingConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          timeRecordsListingViewConfigurations:
            JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateTimeRecordsListingConfiguration };
